export const SYSTEM_HEALTH_RECEIVED = "SYSTEM_HEALTH_RECEIVED";
export const NODE_STATUS_RECEIVED = "NODE_STATUS_RECEIVED";
export const CLUSTER_FAILOVER_CONFIRMED = "CLUSTER_FAILOVER_CONFIRMED";
export const CLUSTER_HEALTH_RECEIVED = "CLUSTER_HEALTH_RECEIVED";
export const SYSTEM_HEALTH_ERROR = "SYSTEM_HEALTH_ERROR";
export const LOG_DATA_RECEIVED = "LOG_DATA_RECEIVED";
export const SYSTEM_HEALTH_CONNECTED = "SYSTEM_HEALTH_CONNECTED_CHANGED";
export const SYSTEM_HEALTH_ONLINE = "SYSTEM_HEALTH_ONLINE_CHANGED";
